<template>
  <b-card>
    <grupo-empresarial-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :info="info"
      :remover="remover"
      :colunas="colunasListagem"
      :filtros="filtros"
      filtrar-por-ativo
      @removerItem="remover($event)"
    />
  </b-card>
</template>

<style lang="scss">
</style>

<script>
import api from '@/app-modulo/comuns/grupo-empresarial/shared/services/api'

export default {
  name: 'GrupoEmpresarialVisualizacao',
  components: {
    GrupoEmpresarialList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nome', type: 'personalizada', showActive: true, editable: true,
        },
      ],
      filtros: [{ colunas: ['Nome'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getGruposEmpresariais(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-grupo-empresarial' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-grupo-empresarial', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteGrupoEmpresarial(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
  },
}
</script>
